/* eslint-disable @typescript-eslint/indent */
/* eslint-disable prettier/prettier */
import {
  daiGradient,
  dpxGradient,
  ethGradient,
  fraxGradient,
  glpGradient,
  gmxGradient,
  gohmGradient,
  renbtcGradient,
  usdcGradient,
  usdtGradient,
  vestaGradient,
  vst4PoolGradient,
  vstaEthGradient,
} from '~components/theme/styles/colors';
import { AllVestaAssets, ELPType, ENativeAsset, EOtherAsset, EVestaAsset } from '~config/types';

import { ConfigAsset } from './types';

// eslint-disable-next-line prettier/prettier

type AssetConfigReturn = Partial<Record<AllVestaAssets, ConfigAsset>>;

export const ASSET_CONFIG: AssetConfigReturn = {
  [EVestaAsset.ETH]: {
    coingeckoId: 'ethereum',
    decimals: 18,
    styles: {
      crHealthBreakpoints: [2.5, 2, 1.5, 1.3],
      gradient: ethGradient,
      iconSrc: { light: '/v2/assets/ETH-light.svg', dark: '/v2/assets/ETH-dark.svg' },
    },
    dexScreenerGraph: 'https://dexscreener.com/arbitrum/0xc31e54c7a869b9fcbecc14363cf510d1c41fa443',
  },
  [EVestaAsset.gOHM]: {
    coingeckoId: 'governance-ohm',
    decimals: 18,
    styles: {
      crHealthBreakpoints: [3.5, 3, 2.5, 2],
      gradient: gohmGradient,
      iconSrc: { light: '/v2/assets/gOHM-light.svg', dark: '/v2/assets/gOHM-dark.svg' },
    },
    dexScreenerGraph: 'https://dexscreener.com/arbitrum/0xaa5bd49f2162ffdc15634c87a77ac67bd51c6a6d',
  },
  [EVestaAsset.renBTC]: {
    coingeckoId: 'renbtc',
    styles: {
      crHealthBreakpoints: [2.5, 2, 1.5, 1.3],
      gradient: renbtcGradient,
      iconSrc: { light: '/v2/assets/renBTC-light.svg', dark: '/v2/assets/renBTC-dark.svg' },
    },
    decimals: 8,
  },
  [EVestaAsset.DPX]: {
    decimals: 18,
    coingeckoId: 'dopex',
    styles: {
      crHealthBreakpoints: [2.5, 2, 1.7, 1.5],
      gradient: dpxGradient,
      iconSrc: { light: '/v2/assets/DPX-light.svg', dark: '/v2/assets/DPX-dark.svg' },
    },
    dexScreenerGraph: 'https://dexscreener.com/arbitrum/0x0C1Cf6883efA1B496B01f654E247B9b419873054',
  },
  [EVestaAsset.GMX]: {
    decimals: 18,
    coingeckoId: 'gmx',
    styles: {
      crHealthBreakpoints: [2.5, 2, 1.5, 1.3],
      gradient: gmxGradient,
      iconSrc: { light: '/v2/assets/GMX-light.svg', dark: '/v2/assets/GMX-dark.svg' },
    },
    dexScreenerGraph: 'https://dexscreener.com/arbitrum/0x1aeedd3727a6431b8f070c0afaa81cc74f273882',
  },
  [EVestaAsset.sGLP]: {
    decimals: 18,
    styles: {
      crHealthBreakpoints: [2.5, 2, 1.5, 1.3],
      gradient: glpGradient,
      iconSrc: { light: '/v2/assets/GLP-light.svg', dark: '/v2/assets/GLP-dark.svg' },
    },
  },
  [EVestaAsset.ARB]: {
    decimals: 18,
    coingeckoId: 'arbitrum',
    styles: {
      crHealthBreakpoints: [2.5, 2, 1.5, 1.3],
      gradient: glpGradient,
      iconSrc: { light: '/v2/networks/arbitrum.svg', dark: '/v2/networks/arbitrum.svg' },
    },
    dexScreenerGraph: 'https://dexscreener.com/arbitrum/0xc6f780497a95e246eb9449f5e4770916dcd6396a',
  },
  [EVestaAsset.wstETH]: {
    decimals: 18,
    coingeckoId: 'wrapped-steth',
    styles: {
      crHealthBreakpoints: [2.5, 2, 1.5, 1.35],
      gradient: glpGradient,
      iconSrc: { light: '/v2/assets/wsteth.webp', dark: '/v2/assets/wsteth.webp' },
    },
    dexScreenerGraph: 'https://dexscreener.com/arbitrum/0xb93f8a075509e71325c1c2fc8fa6a75f2d536a13',
  },
  // LPs
  [ELPType['VSTA-ETH']]: {
    decimals: 18,
    tokenComposition: [ENativeAsset.VSTA, EVestaAsset.ETH],
    styles: {
      gradient: vstaEthGradient,
    },
  },
  [ELPType['VST-USDC']]: {
    decimals: 18,
    tokenComposition: [ENativeAsset.VST, EOtherAsset.USDC],
    styles: {
      gradient: vstaEthGradient,
    },
  },
  [ELPType['VST-FRAX']]: {
    decimals: 18,
    tokenComposition: [ENativeAsset.VST, EOtherAsset.FRAX],
    styles: {
      gradient: fraxGradient,
    },
  },
  [ELPType['VST-USDC-DAI-USDT']]: {
    decimals: 18,
    tokenComposition: [ENativeAsset.VST, EOtherAsset.USDC, EOtherAsset.DAI, EOtherAsset.USDT],
    styles: {
      gradient: vst4PoolGradient,
      iconSrc: {
        light: '/v2/assets/VST-USDC-DAI-USDT-light.svg',
        dark: '/v2/assets/VST-USDC-DAI-USDT-dark.svg',
      },
    },
  },
  // Vesta Native Assets
  [ENativeAsset.VST]: {
    decimals: 18,
    coingeckoId: 'vesta-stable',
    styles: {
      iconSrc: {
        light: '/v2/assets/VST-light.svg',
        dark: '/v2/assets/VST-dark.svg',
      },
      gradient: vestaGradient,
    },
  },
  [ENativeAsset.VSTA]: {
    decimals: 18,
    coingeckoId: 'vesta-finance',
    styles: {
      iconSrc: {
        light: '/v2/assets/VSTA-light.svg',
        dark: '/v2/assets/VSTA-dark.svg',
      },
      gradient: vestaGradient,
    },
    dexScreenerGraph:
      'https://dexscreener.com/arbitrum/0xc61ff48f94d801c1ceface0289085197b5ec44f000020000000000000000004d-0x82af49447d8a07e3bd95bd0d56f35241523fbab1-0xa684cd057951541187f288294a1e1c2646aa2d24',
  },
  //@TODO change to actual bVSTA info when possible
  [ENativeAsset.bVSTA]: {
    decimals: 18,
    coingeckoId: 'vesta-finance',
    styles: {
      iconSrc: {
        light: '/v2/assets/bVSTA.svg',
        dark: '/v2/assets/bVSTA.svg',
      },
      gradient: vestaGradient,
    },
    dexScreenerGraph:
      'https://dexscreener.com/arbitrum/0xc61ff48f94d801c1ceface0289085197b5ec44f000020000000000000000004d-0x82af49447d8a07e3bd95bd0d56f35241523fbab1-0xa684cd057951541187f288294a1e1c2646aa2d24',
  },
  //Other Assets
  [EOtherAsset.USDC]: {
    coingeckoId: 'usd-coin',
    styles: {
      iconSrc: {
        light: '/img/assets/usdc.svg',
        dark: '/img/assets/usdc.svg',
      },
      gradient: usdcGradient,
    },
    decimals: 6,
  },
  [EOtherAsset.DAI]: {
    decimals: 18,
    coingeckoId: 'dai',
    styles: {
      iconSrc: {
        light: '/img/assets/dai.svg',
        dark: '/img/assets/dai.svg',
      },
      gradient: daiGradient,
    },
  },
  [EOtherAsset.USDT]: {
    coingeckoId: 'tether',
    styles: {
      iconSrc: {
        light: '/img/assets/usdt.svg',
        dark: '/img/assets/usdt.svg',
      },
      gradient: usdtGradient,
    },
    decimals: 6,
  },
  [EOtherAsset.FRAX]: {
    decimals: 18,
    coingeckoId: 'frax',
    styles: {
      iconSrc: {
        light: '/v2/assets/FRAX-light.svg',
        dark: '/v2/assets/FRAX-dark.svg',
      },
      gradient: fraxGradient,
    },
    dexScreenerGraph: 'https://dexscreener.com/arbitrum/0xfe3b6dd9457e13b2f44b9356e55fc5e6248b27ba',
  },
  [EOtherAsset.FXS]: {
    decimals: 18,
    coingeckoId: 'frax-share',
    styles: {
      iconSrc: {
        light: '/v2/assets/FXS-light.svg',
        dark: '/v2/assets/FXS-dark.svg',
      },
      gradient: fraxGradient,
    },
  },
  [EOtherAsset.BAL]: {
    decimals: 18,
    coingeckoId: 'balancer',
    styles: {
      iconSrc: {
        light: '/v2/assets/BAL-light.svg',
        dark: '/v2/assets/BAL-dark.svg',
      },
      gradient: fraxGradient,
    },
  },
  [EOtherAsset.vwDPX]: {
    decimals: 18,
    styles: {
      iconSrc: { light: '/v2/assets/DPX-light.svg', dark: '/v2/assets/DPX-dark.svg' },
      gradient: dpxGradient,
    },
  },
  [EOtherAsset.vwGMX]: {
    decimals: 18,
    styles: {
      iconSrc: { light: '/v2/assets/GMX-light.svg', dark: '/v2/assets/GMX-dark.svg' },
      gradient: gmxGradient,
    },
  },
  [EOtherAsset.WETH]: {
    decimals: 18,
    coingeckoId: 'ethereum',
    styles: {
      gradient: ethGradient,
      iconSrc: { light: '/v2/assets/ETH-light.svg', dark: '/v2/assets/ETH-dark.svg' },
    },
  },
};

export const coingeckoConfig = Object.entries(ASSET_CONFIG).reduce((acc, [asset, config]) => {
  if (config.coingeckoId) {
    acc[config.coingeckoId] = asset as AllVestaAssets;
  }
  return acc;
}, {} as Record<string, AllVestaAssets>);
